import _styled from "styled-components";
export var selectLabelStyle = {
  "marginBottom": "0.5rem",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
};
export var selectSecondaryLabelStyle = {
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(117 117 131 / var(--tw-text-opacity))"
};
export var selectInteractiveAreaStyle = {
  "position": "relative",
  "display": "flex",
  "height": "3rem",
  "width": "100%",
  "cursor": "pointer",
  "appearance": "none",
  "alignItems": "center",
  "justifyContent": "space-between",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(133 133 145 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "paddingTop": "0.75rem",
  "paddingBottom": "0.75rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "textAlign": "left",
  "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "200ms",
  ":hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(235 235 237 / var(--tw-bg-opacity))"
  },
  ":focus-visible": {
    "outlineWidth": "8px",
    "outlineColor": "#e88a99"
  },
  ":disabled": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))"
  }
};
export var selectInteractiveAreaContentStyle = {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
};
export var selectOptionsStyle = {
  "zIndex": "200",
  "maxHeight": "305px",
  "overflow": "auto",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(133 133 145 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "padding": "0.5rem",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "--tw-shadow": "0px 4px 16px 0px rgba(0, 0, 26, 0.25)",
  "--tw-shadow-colored": "0px 4px 16px 0px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
  "@media (min-width: 1280px)": {
    "maxHeight": "360px"
  }
};
export var selectOptionStyle = {
  "position": "relative",
  "display": "flex",
  "height": "3rem",
  "cursor": "pointer",
  "userSelect": "none",
  "alignItems": "center",
  "paddingTop": "0px",
  "paddingBottom": "0px",
  "paddingLeft": "1.25rem",
  "paddingRight": "1.25rem",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))",
  ":hover": {
    "borderRadius": "0.5rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(235 235 237 / var(--tw-bg-opacity))"
  }
};
export var SelectMainWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "selectstyled__SelectMainWrapper",
  componentId: "sc-18pc6xt-0"
})(["", " ", ""], function (_ref) {
  var fullwidth = _ref.fullwidth;
  return fullwidth ? {
    "width": "100%"
  } : {
    "width": "320px"
  };
}, function (_ref2) {
  var twStyle = _ref2.twStyle;
  return twStyle || {};
});
export var ListboxContentWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "selectstyled__ListboxContentWrapper",
  componentId: "sc-18pc6xt-1"
})(["", ""], {
  "position": "relative",
  "marginTop": "0.25rem"
});
export var SecondaryLabel = /*#__PURE__*/_styled.span.withConfig({
  displayName: "selectstyled__SecondaryLabel",
  componentId: "sc-18pc6xt-2"
})(["", ""], selectSecondaryLabelStyle);
export var ListboxButtonContent = /*#__PURE__*/_styled.span.withConfig({
  displayName: "selectstyled__ListboxButtonContent",
  componentId: "sc-18pc6xt-3"
})(["", " ", " ", ""], selectInteractiveAreaContentStyle, {
  "display": "inline-block",
  "overflow": "hidden",
  "textOverflow": "ellipsis",
  "whiteSpace": "nowrap",
  "paddingRight": "0.5rem"
}, function (_ref3) {
  var twStyle = _ref3.twStyle;
  return twStyle || {};
});
export var IconAndTextWrapper = /*#__PURE__*/_styled.span.withConfig({
  displayName: "selectstyled__IconAndTextWrapper",
  componentId: "sc-18pc6xt-4"
})(["", ""], {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.5rem"
});
export var ArrowIconWrapper = /*#__PURE__*/_styled.span.withConfig({
  displayName: "selectstyled__ArrowIconWrapper",
  componentId: "sc-18pc6xt-5"
})(["", " ", ";"], {
  "minWidth": "24px",
  "transitionProperty": "transform",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms"
}, function (_ref4) {
  var isOpen = _ref4.isOpen;
  return isOpen ? {
    "--tw-rotate": "180deg",
    "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
  } : {};
});
export var StyledSelectHelperText = /*#__PURE__*/_styled.span.withConfig({
  displayName: "selectstyled__StyledSelectHelperText",
  componentId: "sc-18pc6xt-6"
})(["", " ", ""], {
  "marginTop": "0.5rem",
  "display": "inline-block",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "400"
}, function (_ref5) {
  var variant = _ref5.variant;
  return variant === 'error' ? {
    "--tw-text-opacity": "1",
    "color": "rgb(204 0 34 / var(--tw-text-opacity))"
  } : variant === 'success' ? {
    "--tw-text-opacity": "1",
    "color": "rgb(0 119 64 / var(--tw-text-opacity))"
  } : {
    "--tw-text-opacity": "1",
    "color": "rgb(28 28 51 / var(--tw-text-opacity))"
  };
});
export var StyledPlaceholder = /*#__PURE__*/_styled.span.withConfig({
  displayName: "selectstyled__StyledPlaceholder",
  componentId: "sc-18pc6xt-7"
})(["", ""], {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))"
});